import { render, staticRenderFns } from "./WsSortDialog.vue?vue&type=template&id=4ce4e71b&"
import script from "./WsSortDialog.vue?vue&type=script&lang=js&"
export * from "./WsSortDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports